interface LogoProps {
  size?: 'sm' | 'md' | 'lg'
  showIcon?: boolean
  /** `dark` is opt-in. Dashboard and Auth render on light chrome and must
   *  keep the default. */
  tone?: 'light' | 'dark'
  className?: string
}

const TEXT_SIZE = {
  sm: 'text-lg',
  md: 'text-xl',
  lg: 'text-2xl',
} as const

const MARK_SIZE = {
  sm: 20,
  md: 24,
  lg: 30,
} as const

/**
 * Two faint text lines resolving into one solid card — the product in a
 * single glyph. The accent falls only on the card, because the card is the
 * output. The `2` in the wordmark is the word "to", so it is the one glyph
 * worth colouring.
 */
export default function Logo({
  size = 'md',
  showIcon = true,
  tone = 'light',
  className = '',
}: LogoProps) {
  const isDark = tone === 'dark'
  const px = MARK_SIZE[size]

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {showIcon && (
        <svg
          width={px}
          height={px}
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
          className={`shrink-0 ${isDark ? 'text-white' : 'text-gray-900'}`}
        >
          <rect x="4" y="4" width="16" height="2.1" rx="1.05" fill="currentColor" opacity="0.3" />
          <rect x="4" y="9" width="10.5" height="2.1" rx="1.05" fill="currentColor" opacity="0.3" />
          <rect
            x="3"
            y="14.2"
            width="18"
            height="6.8"
            rx="2.4"
            className={isDark ? 'fill-primary-400' : 'fill-primary-500'}
          />
        </svg>
      )}
      <span
        className={`font-semibold tracking-[-0.022em] ${TEXT_SIZE[size]} ${
          isDark ? 'text-white' : 'text-gray-900'
        }`}
      >
        <span>notes</span>
        <span className={isDark ? 'text-primary-400' : 'text-primary-600'}>2</span>
        <span>board</span>
      </span>
    </div>
  )
}
